export default {
  ApiDomain: "api-dev.hipaamate.com",
  AppDomain: "app-dev.hipaamate.com",
  GTag: "UA-111671952-3",
  OIGDomain: "oig-dev.hipaamate.com",
  Region: "us-east-2",
  Stage: "dev",
  StripeKey: "pk_test_tQHopqwalirs42Yr1MsvWdgS",
  Version: "2.3.18",
  WebDomain: "dev.hipaamate.com"
};
